<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <h1 class="title-default">Suprimentos</h1>
    <p class="welcome-message">
      Bem vindo ao módulo <span class="display-name">Suprimentos</span>! Aqui você encontra as rotinas de estoque e
      movimentação de produtos.
    </p>
    <app-lista-funcionalidade [moduloEnum]="moduloEnum"></app-lista-funcionalidade>
  </div>
</div>
